<template>
  <breadCrumbs title="Payment Details" main="Ecommerce" title1="Payment Details" />

  <div class="container-fluid credit-card payment-details">
    <div class="row">

      <creditCard />

      <debitCard />

      <codCard />

      <emiCard />

      <netBanking />

    </div>
  </div>
</template>
<script>
import netBanking from "./netBanking.vue"
import creditCard from "./creditCard.vue"
import debitCard from "./debitCard.vue"
import codCard from "./codCard.vue"
import emiCard from "./emiCard.vue"
export default {
  components: {
    netBanking,
    creditCard,
    debitCard,
    codCard,
    emiCard
  },
  name: 'paymentDetails'
}
</script>